"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactChartjs = require("react-chartjs-2");

var _resizeObserver = require("resize-observer");

var _Error = _interopRequireDefault(require("./Error"));

var _Loader = _interopRequireDefault(require("./Loader"));

var _chartOptions = _interopRequireDefault(require("./chartOptions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

(0, _resizeObserver.install)();

var mapData = function mapData(data) {
  return {
    labels: data.map(function (x) {
      return x.financialWeek;
    }),
    datasets: [{
      backgroundColor: 'rgba(240, 108, 0, 1)',
      data: data.map(function (x) {
        return x.compliance;
      })
    }]
  };
};

var ComplianceChart = function ComplianceChart(_ref) {
  var loading = _ref.loading,
      error = _ref.error,
      data = _ref.data;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loading && /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "ln-u-margin-top*2",
    message: "Fetching compliance data"
  }), error && /*#__PURE__*/_react.default.createElement(_Error.default, {
    className: "ln-u-margin-top*2",
    message: "Oh no, an error has occurred fetching compliance data, please try again!"
  }), !loading && !error && /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, {
    data: mapData(data),
    options: _chartOptions.default
  }));
};

ComplianceChart.propTypes = {
  data: _propTypes.default.array.isRequired,
  loading: _propTypes.default.bool,
  error: _propTypes.default.bool
};
ComplianceChart.defaultProps = {
  loading: false,
  error: false
};
var _default = ComplianceChart;
exports.default = _default;